// @flow

import { DEFAULT_LANGUAGE } from '@chatchamp/chatchamp-types'

import enUS from './en_US'
import deDE from './de_DE'
import nlNL from './nl_NL'
import noNO from './no_NO'
import daDK from './da_DK'
import svSE from './sv_SE'
import arAA from './ar_AA'
import frFR from './fr_FR'
import itIT from './it_IT'
import esES from './es_ES'

export const defaultLocale = DEFAULT_LANGUAGE

export const messages = {
  en_US: enUS,
  de_DE: deDE,
  nl_NL: nlNL,
  no_NO: noNO,
  da_DK: daDK,
  sv_SE: svSE,
  ar_AA: arAA,
  fr_FR: frFR,
  it_IT: itIT,
  es_ES: esES
}
